/** The plan slugs a `data-cmb-plan` value names, split on spaces or commas. */
export const readPlans = (value: string | null | undefined): string[] =>
  (value || '')
    .split(/[\s,]+/)
    .map((slug) => slug.trim())
    .filter(Boolean);
